import PoliticalDashboardPage from "./pages/politicalParty/PoliticalPages/PoliticalDashboardPage";
import PoliticalDocumentPage from "./pages/politicalParty/PoliticalPages/PoliticalDocumentPage";
import PoliticalExecutiveMembersPage from "./pages/politicalParty/PoliticalPages/PoliticalExecutiveMembersPage";
import PoliticalPartyAgentPage from "./pages/politicalParty/PoliticalPages/PoliticalPartyAgentPage";
import PoliticalRegisteredElectorsPage from "./pages/politicalParty/PoliticalPages/PoliticalRegisteredElectorsPage";
import PoliticalRegistredAndNonRegisteredPage from "./pages/politicalParty/PoliticalPages/PoliticalRegistredAndNonRegisteredPage";
import PoliticalRepresentativesPage from "./pages/politicalParty/PoliticalPages/PoliticalRepresentativesPage";
import { Reports } from "./pages/reports/Reports";

export const menu = [
	{
		label: "Home",
		items: [
			{
				label: "Dashboard",
				icon: "pi pi-fw pi-home",
				to: "/"
			},
			{
				label: "Executive Committee ",
				icon: "pi pi-fw pi-bookmark",
				to: "/executive-members"
			},
			{
				label: "Paid up Membership ",
				icon: "pi pi-fw pi-bookmark",
				to: "/members"
			},
			{
				label: "Agents",
				icon: "pi pi-fw pi-bookmark",
				to: "/party-agent"
			}, {
				label: "Party List",
				icon: "pi pi-fw pi-bookmark",
				to: "/proportional-representation"
			},
			{
				label: "Documents",
				icon: "pi pi-fw pi-bookmark",
				to: "/documents"
			},

			{
				label: "Voter's Register",
				icon: "pi pi-fw pi-bookmark",
				to: "/reports"
			}
		]
	}
];

export function PoliticalSelfServiceSiteGenerateRoutesAndMenu(azureLoginState) {
	var routes = {
		"/": { component: PoliticalDashboardPage },
		"/members": { component: PoliticalRegistredAndNonRegisteredPage },
		"/executive-members": { component: PoliticalExecutiveMembersPage },
		"/documents": { component: PoliticalDocumentPage },
		"/party-agent": { component: PoliticalPartyAgentPage },
		"/proportional-representation": { component: PoliticalRepresentativesPage },
		"/reports": { component: () =>  <Reports
			isPortal={true} 
			reportType={{
				Name:"Elector Register",
				Type:"registerReports"
			}}/> }
	};

	return { menu: menu, routes: routes };
}
